const templateUrl = require("ngtemplate-loader!html-loader!./alertas.component.html")

angular.module("fichaAlumnoModule").component("alertas", {
  templateUrl: templateUrl,
  bindings: {
    alumnoId: "<",
    crear: "<",
    customCallback: "<",
    parentCallback: "<"
  },
  controller: [
    "AlertaService",
    "ComentarioService",
    "permissionService",
    function AlertasController(AlertaService, ComentarioService, permissionService) {
      var self = this

      self.modelName = "alertas"

      self._columns = [
        {
          key: "tipo_alerta",
          value: "tipo de alerta"
        },
        {
          key: "fecha_ingreso",
          value: "fecha de ingreso"
        },
        {
          key: "creador",
          value: "ingresado por"
        },
        {
          key: "responsable",
          value: "responsable"
        },
        {
          key: "estado",
          value: "estado actual"
        }
      ]

      self.menuOptions = [
        {
          name: "Ver Comentarios",
          callback: "custom",
          args: self.customCallback
        },
        {
          name: "Cambiar Estado",
          callback: "editRow",
          args: "estado"
        },
        {
          name: "Eliminar",
          callback: "deleteRow"
        }
      ]

      self.crudMenu = [
        {
          action: "crear",
          icon_name: "add",
          callback: "create"
        },
        {
          action: "estado",
          icon_name: "mode_edit",
          callback: "editModels"
        },
        {
          action: "eliminar",
          icon_name: "delete",
          callback: "delete"
        }
      ]

      if (!permissionService.eliminarAlertas()) {
        self.menuOptions.splice(-1, 1)
        self.crudMenu.splice(-1, 1)
      }

      self.onCreate = function(post_data, callback) {
        post_data["matricula_id"] = self.alumnoId

        console.log(post_data)
        return AlertaService.save(post_data).$promise.then(function(alerta_creada) {
          if (post_data.comentario !== "") {
            ComentarioService.save({
              object_pk: alerta_creada.id,
              modelName: "alerta",
              comment: post_data.comentario
            }).$promise.then(function(data) {
              if (callback) {
                callback()
                if (self.parentCallback) {
                  self.parentCallback()
                }
              }
            })
          } else {
            if (callback) {
              callback()
            }
          }
        })
      }

      self.onEdit = function(models) {
        return AlertaService.update(models).$promise.then(function(data) {
          return { status: true }
        })
      }

      self.onDelete = function(models) {
        return AlertaService.remove({ "ids[]": models }).$promise
      }

      self._getModels = function() {
        return AlertaService.query({ matricula_id: self.alumnoId }).$promise
      }
    }
  ]
})
